import axios, { AxiosInstance, AxiosRequestConfig } from 'axios';
import { API_CONFIG } from '../config/apiConfig';

// Create axios instance with interceptors (similar to oss-web-ui pattern)
export const apiClient: AxiosInstance = axios.create({
  baseURL: API_CONFIG.BASE_URL,
  timeout: API_CONFIG.TIMEOUT,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add request interceptor to automatically include auth headers from sessionStorage
const reqId = Math.floor(Math.random() * 1000000);
apiClient.interceptors.request.use(
  (config) => {
    const sessionId = sessionStorage.getItem('sessionId') || '';
    const userId = sessionStorage.getItem('user') || '';
    const respId = sessionStorage.getItem('respId') || '';
    const username = sessionStorage.getItem('username') || '';

    // Add required headers for Trident authorizer
    config.headers['sessionid'] = sessionId;
    config.headers['userid'] = userId;
    config.headers['respid'] = respId;
    config.headers['username'] = username;
    config.headers['x-amzn-trace-id'] = `RADWeb_${sessionId}_${reqId}`;

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);